import React, { Component } from 'react'


class AccountPaiments extends Component {

    
    render() {
        return(
          <div>
            <h2>Paiements</h2>
            <table style={{ width:"100%" }} cellPadding="0" cellSpacing="0">
            <tbody>
            { this.props.paiments.map((paiment)=>{ return(
              <tr key={paiment.id}>
                <td>{ paiment.datetext }</td>
                <td>{ paiment.descriptiontext }</td>
                <td>{ paiment.pricetext }</td>
              </tr>
            )})}
            </tbody>
            </table>
          </div>
        );
    }
}

export default AccountPaiments;
